module.exports = __webpack_public_path__ + "img/icn_charms.3b09ba74.svg";